<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <router-link to="/" class="brand">
        <img src="/logo-localizce.png" alt="Localizce Logo" class="logo-img" />
      </router-link>
      <button class="hamburger" @click="toggleMenu">
        <i class="mdi" :class="isMenuOpen ? 'mdi-close' : 'mdi-menu'"></i>
      </button>
    </div>

    <div class="mobile-menu" :class="{ 'is-active': isMenuOpen }">
      <div class="navbar-menu">
        <router-link
          v-if="isAuthenticated"
          to="/"
          class="nav-item"
          active-class="active"
          @click="closeMenu"
        >
          <i class="mdi mdi-map"></i>
          <span>Carte</span>
        </router-link>
        <router-link
          v-if="isAuthenticated"
          to="/devices"
          class="nav-item"
          active-class="active"
          @click="closeMenu"
        >
          <i class="mdi mdi-devices"></i>
          <span>Appareils</span>
        </router-link>
        <router-link
          v-if="isAuthenticated && hasGroupFeature"
          to="/groups"
          class="nav-item"
          active-class="active"
          @click="closeMenu"
        >
          <i class="mdi mdi-account-group"></i>
          <span>Groupes</span>
        </router-link>
        <router-link
          v-if="isAuthenticated"
          to="/alerts"
          class="nav-item"
          active-class="active"
          @click="closeMenu"
        >
          <i class="mdi mdi-alert"></i>
          <span>Alertes</span>
        </router-link>
        <router-link
          v-if="isAdmin"
          to="/users"
          class="nav-item"
          active-class="active"
          @click="closeMenu"
        >
          <i class="mdi mdi-account-multiple"></i>
          <span>Utilisateurs</span>
        </router-link>
      </div>

      <div class="navbar-end">
        <div class="user-menu" v-if="authStore.isLoggedIn">
          <button class="user-button" @click="toggleUserMenu">
            <div class="user-avatar">
              <img
                v-if="authStore.getUser"
                :src="userService.getProfileImageUrl(authStore.getUser)"
                alt="Profile"
                class="profile-image"
              />
              <i v-else class="mdi mdi-account-circle"></i>
            </div>
            <span>{{ authStore.getUser?.email }}</span>
            <i class="mdi mdi-chevron-down"></i>
          </button>
          <div class="user-dropdown" v-if="showUserMenu">
            <button
              class="dropdown-item"
              @click="stopImpersonating"
              v-if="authStore.isImpersonating"
            >
              <i class="mdi mdi-account-switch"></i>
              <span>Revenir à mon compte</span>
            </button>
            <router-link to="/settings" class="dropdown-item" @click="closeUserMenu">
              <i class="mdi mdi-cog"></i>
              <span>Paramètres</span>
            </router-link>
            <button class="dropdown-item" @click="logout">
              <i class="mdi mdi-logout"></i>
              <span>Déconnexion</span>
            </button>
          </div>
        </div>
        <router-link v-if="!isAuthenticated" to="/login" class="login-button" @click="closeMenu">
          <i class="mdi mdi-login"></i>
          <span>Connexion</span>
        </router-link>
        <router-link v-if="!isAuthenticated" to="/register" class="login-button" @click="closeMenu">
          <i class="mdi mdi-account-plus"></i>
          <span>Inscription</span>
        </router-link>
      </div>
    </div>

    <div class="desktop-menu">
      <div class="navbar-menu">
        <router-link v-if="isAuthenticated" to="/" class="nav-item" active-class="active">
          <i class="mdi mdi-map"></i>
          <span>Carte</span>
        </router-link>
        <router-link v-if="isAuthenticated" to="/devices" class="nav-item" active-class="active">
          <i class="mdi mdi-devices"></i>
          <span>Appareils</span>
        </router-link>
        <router-link
          v-if="isAuthenticated && hasGroupFeature"
          to="/groups"
          class="nav-item"
          active-class="active"
        >
          <i class="mdi mdi-account-group"></i>
          <span>Groupes</span>
        </router-link>
        <router-link v-if="isAuthenticated" to="/alerts" class="nav-item" active-class="active">
          <i class="mdi mdi-alert"></i>
          <span>Alertes</span>
        </router-link>
        <router-link v-if="isAdmin" to="/users" class="nav-item" active-class="active">
          <i class="mdi mdi-account-multiple"></i>
          <span>Utilisateurs</span>
        </router-link>
      </div>

      <div class="navbar-end">
        <div class="user-menu" v-if="authStore.isLoggedIn">
          <button class="user-button" @click="toggleUserMenu">
            <div class="user-avatar">
              <img
                v-if="authStore.getUser"
                :src="userService.getProfileImageUrl(authStore.getUser)"
                alt="Profile"
                class="profile-image"
              />
              <i v-else class="mdi mdi-account-circle"></i>
            </div>
            <span>{{ authStore.getUser?.name || authStore.getUser?.email }}</span>
            <i class="mdi mdi-chevron-down"></i>
          </button>
          <div class="user-dropdown" v-if="showUserMenu">
            <button
              class="dropdown-item"
              @click="stopImpersonating"
              v-if="authStore.isImpersonating"
            >
              <i class="mdi mdi-account-switch"></i>
              <span>Revenir à mon compte</span>
            </button>
            <router-link to="/settings" class="dropdown-item" @click="closeUserMenu">
              <i class="mdi mdi-cog"></i>
              <span>Paramètres</span>
            </router-link>
            <button class="dropdown-item" @click="logout">
              <i class="mdi mdi-logout"></i>
              <span>Déconnexion</span>
            </button>
          </div>
        </div>
        <router-link v-if="!isAuthenticated" to="/login" class="login-button">
          <i class="mdi mdi-login"></i>
          <span>Connexion</span>
        </router-link>
        <router-link v-if="!isAuthenticated" to="/register" class="login-button">
          <i class="mdi mdi-account-plus"></i>
          <span>Inscription</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { APP_CONFIG } from '@/config/app.config'
import { useToast } from 'vue-toastification'
import { userService } from '@/services/userService'

const router = useRouter()
const authStore = useAuthStore()
const showUserMenu = ref(false)
const isMenuOpen = ref(false)
const isAuthenticated = computed(() => authStore.isAuthenticated)
const isAdmin = computed(() => authStore.getUser?.is_admin)
const hasGroupFeature = computed(() => authStore.getUser?.features?.Group === true)
const toast = useToast()

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const closeMenu = () => {
  isMenuOpen.value = false
}

const toggleUserMenu = () => {
  showUserMenu.value = !showUserMenu.value
}

const closeUserMenu = () => {
  showUserMenu.value = false
}

const logout = async () => {
  authStore.logout()
  router.push('/login')
}

const stopImpersonating = async () => {
  try {
    const success = await authStore.stopImpersonating()
    if (success) {
      toast.success('Vous êtes revenu à votre compte administrateur')
      router.push('/users')
    } else {
      toast.error('Erreur lors du retour à votre compte')
    }
  } catch (error) {
    console.error('Erreur lors du retour à votre compte:', error)
    toast.error('Erreur lors du retour à votre compte')
  }
}

// Fermer le menu utilisateur quand on clique ailleurs
const closeUserMenuOnClick = (e) => {
  if (!e.target.closest('.user-menu')) {
    showUserMenu.value = false
  }
}

// Ajouter et retirer l'écouteur d'événements
onMounted(() => {
  document.addEventListener('click', closeUserMenuOnClick)
})

onUnmounted(() => {
  document.removeEventListener('click', closeUserMenuOnClick)
})
</script>

<style scoped>
.navbar {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 60px;
  flex-grow: 1;
  z-index: 2000;
}

.navbar-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  text-decoration: none;
}

.brand i {
  font-size: 1.5rem;
  color: #3b82f6;
}

.hamburger {
  display: none;
  background: none;
  border: none;
  color: #2d3748;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
}

.navbar-menu {
  display: flex;
  gap: 1rem;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: #64748b;
  text-decoration: none;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
}

.nav-item:hover {
  color: #3b82f6;
  background-color: #f1f5f9;
}

.nav-item.active {
  color: #3b82f6;
  background-color: #eff6ff;
}

.nav-item i {
  font-size: 1.25rem;
}

.navbar-end {
  display: flex;
  align-items: center;
}

.user-menu {
  position: relative;
}

.user-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  color: #2d3748;
  font-weight: 500;
  cursor: pointer;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
}

.user-button:hover {
  background-color: #f1f5f9;
}

.user-button i {
  font-size: 1.25rem;
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background-color: white;
  border-radius: 0.375rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 50;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  color: #2d3748;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f1f5f9;
  color: #3b82f6;
}

.dropdown-item i {
  font-size: 1.25rem;
}

.login-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
}

.login-button:hover {
  background-color: #eff6ff;
}

.login-button i {
  font-size: 1.25rem;
}

.dropdown-item i.mdi-account-switch {
  color: #0284c7;
}

.user-avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar i {
  font-size: 1.25rem;
  color: #64748b;
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.desktop-menu {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.mobile-menu {
  display: none;
}

.logo-img {
  height: 40px;
  width: auto;
  display: block;
}

@media (max-width: 768px) {
  .hamburger {
    display: block;
  }

  .desktop-menu {
    display: none;
  }

  .mobile-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    padding: 1rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    display: none;
    flex-direction: column;
    gap: 1rem;
    z-index: 2000;
    overflow-y: auto;
  }

  .mobile-menu.is-active {
    display: flex;
  }

  .mobile-menu .navbar-menu {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .mobile-menu .navbar-end {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .nav-item,
  .login-button {
    width: 100%;
    justify-content: flex-start;
    padding: 1rem;
  }

  .user-menu {
    width: 100%;
  }

  .user-button {
    width: 100%;
    justify-content: flex-start;
    padding: 1rem;
  }

  .user-dropdown {
    position: static;
    margin-top: 0.5rem;
    box-shadow: none;
    border-top: 1px solid #e2e8f0;
  }

  .logo-img {
    height: 32px;
  }
}
</style>
